import { IState } from '../../store';
import { selectInfrastructureFromBuilder, selectTransportAccessibility } from '../transportAccessibility';

export const getIsTransportAccessibilityServiceAvailable = (state: IState) => {
  const transportAccessibility = selectTransportAccessibility(state);
  const infrastructureFromBuilder = selectInfrastructureFromBuilder(state);

  return Boolean(transportAccessibility || infrastructureFromBuilder);
};
